import { render, staticRenderFns } from "./CustomForm.vue?vue&type=template&id=3a24aea3"
import script from "./CustomForm.vue?vue&type=script&lang=ts"
export * from "./CustomForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports